import {
  SET_CIRCUIT_BREAKER_CONFIG,
  SET_FEED_CONFIG,
  SET_FEED_CONFIG_HISTORY,
  SET_FEED_CONFIG_UNIQUE_CREATOR,
  SET_LOADING,
} from '../constants/FeedConfig';

const initState = {
  config: {
    NotificationEmail: '',
    CutOffReminderInternal: 0,
    ManualPriceReminderInternal: 0,
  },
  circuitBreakerConfig: [],
  configHistory: {
    rows: [],
    count: 0,
  },
  configUniqueCreator: [],
  loading: false,
};

const feedConfig = (state = initState, action) => {
  switch (action.type) {
    case SET_FEED_CONFIG:
      return {
        ...state,
        config: action.payload,
      };
    case SET_CIRCUIT_BREAKER_CONFIG:
      return {
        ...state,
        circuitBreakerConfig: action.payload,
      };
    case SET_FEED_CONFIG_HISTORY:
      return {
        ...state,
        configHistory: action.payload,
      };
    case SET_FEED_CONFIG_UNIQUE_CREATOR:
      return {
        ...state,
        configUniqueCreator: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default feedConfig;
